import { render } from "./EmptyBlock.vue?vue&type=template&id=aac7abf8&scoped=true"
import script from "./EmptyBlock.vue?vue&type=script&lang=js"
export * from "./EmptyBlock.vue?vue&type=script&lang=js"

import "./EmptyBlock.vue?vue&type=style&index=0&id=aac7abf8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aac7abf8"]])

export default __exports__